<section class="my-files-section justify-content-center" [ngClass]="{ row: mode === FILE_EXPLORER_MODE.MODIFICATION }">
    <div *ngIf="mode === FILE_EXPLORER_MODE.MODIFICATION" class="col-10 d-flex justify-content-end mb-2 pe-0">
        <ca-upload-progress-container
            *ngIf="(uploader?.queue.length || 0) > 0"
            [uploader]="uploader"
            placement="left"
            [initialUploaderQueueLength]="initialUploaderQueueLength"
            [initialValueOfFilesToBeUploaded]="initialValueOfFilesToBeUploaded$ | async"
            (cancelAllFileUploads)="cancelAllFileUploads()"
            (cancelFileUpload)="cancelFileUpload($event)"
        ></ca-upload-progress-container>
    </div>
    <div class="my-files-wrapper" [ngClass]="{ 'col-10': mode === FILE_EXPLORER_MODE.MODIFICATION }">
        <ca-file-explorer-breadcrumb
            [rootTitle]="getTitle()"
            [hideStaticHome]="true"
            (navigate)="openFolder($event.id)"
            (breadcrumbs)="onHandleBreadcrumbs($event)"
        ></ca-file-explorer-breadcrumb>
        <ca-list-shell
            (onTriggerSearchAndSort)="onTriggerSearch($event)"
            (pageSizeChange)="onPageSizeChange($event)"
            [totalItemsCount]="totalItemsCount$ | async"
            [pageSizeStorageKey]="filesStorageKey"
            [showCategoryButton]="false"
            [isUploadModal]="isUploadModal"
            [sortOptions]="sortOptions"
            [isPageSizeModifiable]="isPageSizeModifiable"
            [pageSize]="defaultPageSize"
            [isSearchLoading]="isSearchLoading"
            [clearSearchQuery]="clearSearchQuery"
            [updateParameterQuery]="updateParameterQuery"
            data-uit="my-files-page-files-list-shell"
            *ngrxLet="currentFolder$; let currentFolder"
        >
            <div *ngIf="mode === FILE_EXPLORER_MODE.MODIFICATION" class="d-flex ms-auto action-btn-wrapper" header>
                <span
                    *ngIf="totalNumberOfFiles > 0 && currentSearchParams.searchQuery !== '' && !(isFolderLoading$ | async)"
                    class="white-space-no-wrap me-4 pt-2"
                    >{{ totalFileResultsText }}</span
                >
                <button
                    type="button"
                    *ngIf="totalNumberOfFiles > 0 && currentSearchParams.searchQuery !== '' && !(isFolderLoading$ | async)"
                    class="btn btn-sm me-3 btn-primary-red"
                    data-uit="delete-by-search-params-btn"
                    (click)="deleteBySearchParams(); $event.stopPropagation()"
                >
                    {{ 'MY_WORKSPACE.MY_FILES.DELETE_ALL_FILES' | translate }}
                </button>
                <button
                    type="button"
                    class="btn ca-btn-icon action-btn rounded-0 me-3"
                    (click)="createFolder()"
                    data-uit="my-files-page-create-folder"
                    triggers="hover"
                    ngbTooltip="{{ 'MY_WORKSPACE.MY_FILES.CREATE_FOLDER' | translate }}"
                    placement="auto"
                >
                    <ca-icon name="folder-add" size="m" [title]="'MY_WORKSPACE.MY_FILES.CREATE_FOLDER' | translate"></ca-icon>
                </button>
                <button
                    type="button"
                    class="btn ca-btn-icon action-btn rounded-0"
                    (click)="isMEDprojectEnabled ? uploadMEDdata() : uploadSection.click()"
                    ngbTooltip="{{ 'MY_WORKSPACE.MY_FILES.UPLOAD_FILES' | translate }}"
                    data-uit="file-upload-btn"
                    triggers="hover"
                    placement="auto"
                >
                    <input #uploadSection type="file" data-uit="file-upload-input" ng2FileSelect [uploader]="uploader" [multiple]="true" hidden />
                    <ca-icon name="upload" size="m" [title]="'MY_WORKSPACE.MY_FILES.UPLOAD_FILES' | translate"></ca-icon>
                </button>
            </div>
            <ca-files-table
                [isFilesPage]="isFilesPage"
                [mode]="mode"
                [columns]="columns"
                [actions]="actions"
                [ngClass]="isUploadModal ? 'isUploadModal' : 'isNotUploadModal'"
                [isUploadOfFilesEnabled]="isUploadOfFilesEnabled"
                [isFilesStatusShown]="isFilesStatusShown"
                class="overflow-table"
                [isLoading]="isFolderLoading$ | async"
                [items]="filesAndFolders"
                [totalNumberOfFiles]="totalNumberOfFiles"
                [totalRowCount]="totalItemsCount$ | async"
                [blobType]="userFileBlobType"
                [folderId]="currentFolder?.id"
                [myFilesClass]="true"
                [stickyHeader]="mode === FILE_EXPLORER_MODE.SELECTION ? true : false"
                [uploaderKey]="UPLOADER_KEY.MY_FILES_UPLOAD_UPLOADER_KEY"
                [cancelUpload]="cancelUpload"
                [cancelAllUploads]="cancelAllUploads"
                [isAddAllFilesClickButtonShown]="
                    (mode === FILE_EXPLORER_MODE.MODIFICATION || mode === FILE_EXPLORER_MODE.SELECTION) && currentFolder && currentFolder.files.length > 0
                "
                [addAllFilesButtonTooltip]="'MY_WORKSPACE.MY_FILES.SELECT_ALL_FILES_TOOLTIP' | translate"
                [truncateFileNameAtWidthOf]="truncateFileNameAtWidthOf"
                (addAllFilesClick)="selectAllFilteredFiles()"
                (onAllUploadsCompleted)="onUploadCompleted()"
                (onUploadCancelled)="uploadCancelled()"
                (renameFolder)="renameFolder($event)"
                (deleteItems)="delete($event)"
                (onOpenFolder)="openFolder($event)"
                (onClickOnFolder)="handleClickOnFolder($event)"
                (onClickOnFile)="handleClickOnFile($event)"
                (changeCustomTags)="onChangeCustomTags($event)"
                (removeTag)="onChangeCustomTags($event)"
                (onFilesAdded)="filesAdded($event)"
                data-uit="my-files-table"
            ></ca-files-table>
        </ca-list-shell>
    </div>
</section>
